import { Navigate, useLocation } from 'react-router-dom';

interface RedirectPreservingQueryProps {
  /** Ziel, optional mit eigenen Parametern (`/settings?tab=schedules`). */
  to: string;
}

/**
 * Weiterleitung, die den Query-String der alten Adresse mitnimmt.
 *
 * `<Navigate to="/" />` wirft ihn weg. Das ist an genau einer Stelle teuer:
 * `/optimization-score?feedcheck=1` steht in der Report-Mail, und `feedcheck=1`
 * ist seit Task 9 die einzige Quelle der Kennzahl `feed_check_report_view`.
 * Die Seite liefe nach dem Verlust unveraendert weiter, nur die Messung waere
 * still tot, also genau die Sorte Schaden, die niemandem auffaellt.
 *
 * Bei Namensgleichheit gewinnen die Parameter des Ziels: sie sind die
 * Routing-Absicht, die alte Adresse ist nur der Weg dorthin.
 */
export function RedirectPreservingQuery({ to }: RedirectPreservingQueryProps) {
  const { search } = useLocation();

  const [pathname, targetSearch = ''] = to.split('?');
  const params = new URLSearchParams(search);
  for (const [key, value] of new URLSearchParams(targetSearch)) {
    params.set(key, value);
  }

  const merged = params.toString();
  return <Navigate to={merged ? `${pathname}?${merged}` : pathname} replace />;
}
